import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EState} from 'src/app/state/reducers';
import {ISignUpState} from '../models/sign-up-state.model';

export const selectSignUpState = createFeatureSelector<ISignUpState>(EState.SignUp);
export const selectCountries = createSelector(selectSignUpState, (signUpState: ISignUpState) => signUpState?.countries);
export const selectCountriesStatus = createSelector(
  selectSignUpState,
  (signUpState: ISignUpState) => signUpState.status.countryStatus
);
export const selectRegions = createSelector(selectSignUpState, (signUpState: ISignUpState) => signUpState?.regions);
export const selectCities = createSelector(selectSignUpState, (signUpState: ISignUpState) => signUpState?.cities);
export const selectMedicalSpecialties = createSelector(
  selectSignUpState,
  (signUpState: ISignUpState) => signUpState?.medicalSpecialties
);
export const selectAccountRequestStatus = createSelector(
  selectSignUpState,
  (signUpState: ISignUpState) => signUpState?.status?.accountRequestStatus
);
export const selectCaptchaResponse = createSelector(
  selectSignUpState,
  (signUpState: ISignUpState) => signUpState?.captchaResponse
);
export const selectResendLinkStatus = createSelector(
  selectSignUpState,
  (signUpState: ISignUpState) => signUpState?.status?.resendLinkStatus
);
